import * as types from '../constants/ActionTypes'





let setTimeOutStatus = (showTimeoutPanel, customerFullUserId) => {
	return {
		type: types.SET_TIMEOUT_STATUS,
		payload: {
			showTimeoutPanel,
			customerFullUserId
		}
	}
}
let switchUserInfo = (isShow) => {
	return {
		type: types.USER_DATA_BASE,
		payload: {isShow}
	}
}


let sessionReqType = (type) => {
	return {
		type: types.SESSION_REQ_TYPE,
		payload: {type}
	}
}


let isOrNoUserInfo = (isShow) => {
	return {
		type: types.IS_OR_NO_USER_INFO,
		payload: {isShow}
	}
}


let currentCustomerInfo = (info) =>{
		return{
			type: types.CURRENT_SESSION_INFO,
			payload:{info}
		}
}
let saveInfoBut = (isShow) =>{
	return{
		type: types.SAVE_INFO_BUT,
		payload:{isShow}
	}
}
export default {
	setTimeOutStatus,
	switchUserInfo,
	sessionReqType,
	isOrNoUserInfo,
	currentCustomerInfo,
	saveInfoBut
}
